export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";